var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoMark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "6.224%",
    cy: "137.133%",
    fx: "6.224%",
    fy: "137.133%",
    r: "331.925%",
    gradientTransform: "matrix(.5849 0 0 1 .026 0)",
    id: "2tu2cy7qwd"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80FFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CF8FD",
    offset: "5.03%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CA1EB",
    offset: "70.34%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#397FE3",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "-22.935%",
    cy: "-106.478%",
    fx: "-22.935%",
    fy: "-106.478%",
    r: "391.259%",
    gradientTransform: "matrix(.5849 0 0 1 -.095 0)",
    id: "2wwf4u79ge"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80FFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CF8FD",
    offset: "5.03%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CA1EB",
    offset: "70.34%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#397FE3",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "-65.138%",
    cy: "146.738%",
    fx: "-65.138%",
    fy: "146.738%",
    r: "518.568%",
    gradientTransform: "matrix(1 0 0 .5909 0 .6)",
    id: "uizjshimvf"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80FFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CF8FD",
    offset: "5.03%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CA1EB",
    offset: "70.34%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#397FE3",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "6.224%",
    cy: "137.135%",
    fx: "6.224%",
    fy: "137.135%",
    r: "331.925%",
    gradientTransform: "matrix(.5849 0 0 1 .026 0)",
    id: "534v9y8adg"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80FFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CF8FD",
    offset: "5.03%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CA1EB",
    offset: "70.34%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#397FE3",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "0%",
    x2: "99.716%",
    y2: "99.716%",
    id: "faxvcw4mmb"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DB8DB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CA0D1",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "c0iarnq34a",
    x: 0,
    y: 0,
    width: 35,
    height: 35,
    rx: 5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "zn04r8mu3c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c0iarnq34a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#faxvcw4mmb)",
    xlinkHref: "#c0iarnq34a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#zn04r8mu3c)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 43.5 26.722 28l26.056 15.114a.446.446 0 0 1 0 .772L26.722 59 0 43.5z",
    fill: "url(#2tu2cy7qwd)",
    opacity: 0.5,
    transform: "translate(-10 -24)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 28.5 26.722 13l26.056 15.114a.446.446 0 0 1 0 .772L26.722 44 0 28.5z",
    fill: "url(#2wwf4u79ge)",
    opacity: 0.79,
    transform: "translate(-10 -24)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#uizjshimvf)",
    opacity: 0.95,
    d: "M1 44.333V15l26 14.667V59z",
    transform: "translate(-10 -24)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 15.5 26.722 0l26.056 15.114a.446.446 0 0 1 0 .772L26.722 31 0 15.5z",
    fill: "url(#534v9y8adg)",
    opacity: 0.9,
    transform: "translate(-10 -24)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.44 9.25c1.186-.002 2.255.695 2.722 1.728l.072.175 1.507 3.357a2.75 2.75 0 0 1 2.504 2.569l.005.171V21c0 .594-.296 1.12-.749 1.435L28.5 23.5a2.25 2.25 0 0 1-4.495.154L24 23.5v-.75H10.5v.75a2.25 2.25 0 0 1-4.495.154L6 23.5v-1.064c-.417-.29-.7-.757-.744-1.292L5.25 21v-3.75a2.75 2.75 0 0 1 2.51-2.74l1.488-3.313a2.999 2.999 0 0 1 2.615-1.94l.196-.007H22.44zM9 22.75H7.5v.75a.75.75 0 0 0 1.493.102L9 23.5v-.75zm18 0h-1.5v.75a.75.75 0 0 0 1.493.102L27 23.5v-.75zM26.5 16H8a1.25 1.25 0 0 0-1.244 1.122l-.006.128V21a.25.25 0 0 0 .197.244L7 21.25h20.5l.053-.006a.25.25 0 0 0 .19-.187L27.75 21v-3.75c0-.69-.56-1.25-1.25-1.25zm-1.375 1.5c.58 0 1.057.439 1.118 1.002l.007.123c0 .58-.439 1.057-1.002 1.118l-.123.007a1.125 1.125 0 1 1 0-2.25zm-15.75 0c.58 0 1.057.439 1.118 1.002l.007.123A1.125 1.125 0 1 1 9.375 17.5zm13.066-6.75H12.058c-.578 0-1.1.33-1.363.876l-.06.14L9.407 14.5h15.684l-1.244-2.777a1.5 1.5 0 0 0-1.264-.966l-.143-.007z",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#zn04r8mu3c)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMark);
export default __webpack_public_path__ + "static/media/logo-mark.11c5da2d.svg";
export { ForwardRef as ReactComponent };